export function trim(str: string, chars?: string): string {
  if (!chars) return str.trim()
  const regex = new RegExp(`^[${chars}]+|[${chars}]+$`, 'g')
  return str.replace(regex, '')
}

export function trimStart(str: string, chars?: string): string {
  if (!chars) return str.trimStart()
  const regex = new RegExp(`^[${chars}]+`, 'g')
  return str.replace(regex, '')
}

export function trimEnd(str: string, chars?: string): string {
  if (!chars) return str.trimEnd()
  const regex = new RegExp(`[${chars}]+$`, 'g')
  return str.replace(regex, '')
}

export function padStart(str: string, length: number, padChar: string = ' '): string {
  return str.padStart(length, padChar)
}

export function padEnd(str: string, length: number, padChar: string = ' '): string {
  return str.padEnd(length, padChar)
}

export function reverse(str: string): string {
  return str.split('').reverse().join('')
}

export function truncate(str: string, length: number, suffix: string = '...'): string {
  if (str.length <= length) return str
  return str.slice(0, length - suffix.length) + suffix
}

export function capitalize(str: string): string {
  if (!str) return str
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase()
}

export function camelCase(str: string): string {
  return str
    .replace(/[-_]+(.)?/g, (_, c) => (c ? c.toUpperCase() : ''))
    .replace(/^(.)/, (c) => c.toLowerCase())
}

export function snakeCase(str: string): string {
  return str
    .replace(/([a-z])([A-Z])/g, '$1_$2')
    .replace(/[-]+/g, '_')
    .toLowerCase()
}

export function kebabCase(str: string): string {
  return str
    .replace(/([a-z])([A-Z])/g, '$1-$2')
    .replace(/[_]+/g, '-')
    .toLowerCase()
}

export function repeat(str: string, count: number): string {
  return str.repeat(count)
}

export function replaceAll(str: string, search: string, replacement: string): string {
  return str.split(search).join(replacement)
}

export function mask(str: string, start: number, end: number, maskChar: string = '*'): string {
  if (start < 0 || end > str.length || start >= end) return str
  const maskLength = end - start
  return str.slice(0, start) + maskChar.repeat(maskLength) + str.slice(end)
}

export function maskPhone(phone: string): string {
  return mask(phone, 3, 7, '*')
}

export function maskEmail(email: string): string {
  const [name, domain] = email.split('@')
  if (!name || !domain) return email
  const maskedName = name.length > 2 ? name.slice(0, 2) + '*'.repeat(name.length - 2) : name
  return `${maskedName}@${domain}`
}

export function maskIDCard(idCard: string): string {
  return mask(idCard, 6, 14, '*')
}

export function maskBankCard(cardNo: string): string {
  return mask(cardNo, 4, cardNo.length - 4, '*')
}
